import { DialogMapStyled, DrawerStyled, Styled } from './index.styles';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Checkbox,
    FormControlLabel,
    SwipeableDrawer,
    Typography,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Button,
    Container,
    Dialog,
    DialogContent,
    IconButton,
    Drawer,
    Breadcrumbs,
    Link,
    Skeleton,
} from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';
import SEO from 'components/seo';
import Footer from 'widgets/footer';
import HotelTicketCard from 'widgets/hotel/hotel-ticket-card';
import MiniAlert from 'components/mini-alert';
import {
    Cancel,
    Close,
    Info,
    Map,
    FilterAlt,
    List as ListIcon,
    ArrowRight,
    AccountCircleOutlined,
} from '@mui/icons-material';
import MapIcon from '@mui/icons-material/Map';
import HotelSearchBar from 'widgets/hotel/hotel-search-bar';
import { routesPaths } from 'config/routes';
import i18n from 'assets/i18n';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Loading } from 'components/loading';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CustomInput from 'components/Input';
import HotelListMap from 'widgets/hotel/hotel-list-map';
import useHotelService from 'services/hotel/index.api';
import { mediaBreakPoints, useMediaScreen } from 'common/theme/media';
import moment from 'moment';
import { hotelUrlGenerator, referenceTypeGenerator } from 'common/utils';
import { t } from 'i18next';
import HotelCityTicketCard from 'widgets/hotel/hotel-city-ticket-card';
import { useSelector } from 'react-redux';
import strapiService from 'services/strapi/index.api';
import DynamicBanners from 'components/dynamic-banners';

interface Item {
    label: string;
    checked: boolean;
    id: number; // veya string, sizin tercihinize bağlı olarak
    minPrice?: number;
    maxPrice?: number;
}

interface dataModel {
    name: string;
    list: Item[];
}

interface AccordionPanelProps {
    data: dataModel;
    expanded: boolean;
    handleCallback: (i?: any, isChecked?: boolean) => void;
}

const AccordionPanel: React.FC<AccordionPanelProps> = ({ data, expanded, handleCallback }) => {
    let isCheckedTrue = data.list.some((item) => item.checked === true);

    return (
        <Accordion
            style={{ display: data.list.length > 0 ? 'block' : 'none' }}
            defaultExpanded={isCheckedTrue}
            key={`${data.name}-${isCheckedTrue}`}
        >
            <AccordionSummary
                expandIcon={expanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
            >
                <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>{data.name}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {data.list.map((item: Item, index: number) => (
                    <FormControlLabel
                        className="form-label"
                        key={item.id}
                        control={
                            <Checkbox
                                defaultChecked={item.checked}
                                onChange={() => {
                                    handleCallback(index, !item.checked);
                                }}
                            />
                        }
                        label={item.label}
                    />
                ))}
            </AccordionDetails>
        </Accordion>
    );
};

const HotelList = () => {
    const media = useMediaScreen();
    const [showMap, setShowMap] = useState<boolean>(false);

    let { location } = useParams();
    const url = useLocation();
    const navigate = useNavigate();
    const { searchList, searchStatic } = useHotelService();

    const { currentCurrency } = useSelector((state: any) => state.currency);

    const [drawer, setDrawer] = useState('');

    const [searchName, setSearchName] = useState<string>('');
    const [searchCity, setSearchCity] = useState<string>('');
    const [searchDistrict, setSearchDistrict] = useState<string>('');
    const [searchVillage, setSearchVillage] = useState<string>('');

    const [loading, setLoading] = useState<boolean>(false);
    const [cityData, setCityData] = useState<any[]>([]);

    const [breadcrumbs, setBreadcrumbs] = useState<any>([]);

    let queryParams = new URLSearchParams(url.search);
    let checkInDate = queryParams.get('checkInDate') || moment().add(1, 'days').format('YYYY-MM-DD');
    let checkOutDate = queryParams.get('checkOutDate') || moment().add(2, 'days').format('YYYY-MM-DD');
    let guest = queryParams.get('guest') || 2;
    let child = queryParams.get('child') || '';
    let sort = queryParams.get('sort');
    let queryMinPrice = queryParams.get('minPrice');
    let queryMaxPrice = queryParams.get('maxPrice');

    let adultGuest = Number(guest);
    let childGuest = child?.includes(',') ? child.split(',').slice(0, 3) : child ? new Array(child) : [];

    const paramsSize = Array.from(queryParams).length;
    const isClearFilter = child ? Boolean(paramsSize > 4) : Boolean(paramsSize > 3);

    // const [minPrice, setMinPrice] = useState<any>(queryMinPrice || '');
    // const [maxPrice, setMaxPrice] = useState<any>(queryMaxPrice || '');

    const arrLocation: string[] = location?.split('-') || [];
    const pCode = arrLocation.pop() || '';
    const pReferenceType = referenceTypeGenerator(pCode);
    // const pLabel = arrLocation.join(', ');

    const [data] = useState<any>({
        location: {
            label: '',
            referenceId: pCode?.slice(1),
            name: '',
            city: '',
            district: '',
            rating: undefined,
            country: '',
            referenceType: pReferenceType,
            starNumber: undefined,
            type: '',
        },
        checkInDate: checkInDate,
        checkOutDate: checkOutDate,
        adultGuest: Math.min(Math.max(isNaN(Number(adultGuest)) ? 0 : Number(adultGuest), 1), 4),
        childArr: childGuest,
        guestCount: Number(adultGuest) + childGuest.length,
    });
    const [mapDialog, setMapDialog] = useState<boolean>(false);
    const [allMockData, setAllMockData] = useState<any[]>([]);
    const [allFilterData, setAllFilterData] = useState<any[]>([]);
    const [mockData, setMockData] = useState<any[]>([]);
    const [page, setPage] = useState(1);
    const [bannerData, setBannerData] = useState<any>();

    const handleBannerData = useCallback(async () => {
        await strapiService
            .NewBanners({
                category: 'hotel',
                subCategory: 'list',
                filters: {
                    toCode: String(data.location?.referenceId),
                    travelType: data.location?.country !== 'TR' ? 'abroad' : 'domestic',
                },
                lang: i18n.language,
            })
            .then((res: any) => {
                setBannerData(res);
            })
            .catch((err: any) => {
                console.log('err:', err);
            });
    }, [i18n.language]);

    const [defaultFilterData, setDefaultFilterData] = useState<any[]>([
        {
            name: t('hotel.list.filter.room.title'),
            value: 'room',
            list: [],
        },
        {
            name: t('hotel.list.filter.vote.title'),
            value: 'vote',
            list: [
                { label: t('hotel.list.filter.vote.list.vote9'), value: 9, checked: false },
                { label: t('hotel.list.filter.vote.list.vote8'), value: 8, checked: false },
                { label: t('hotel.list.filter.vote.list.vote7'), value: 7, checked: false },
                { label: t('hotel.list.filter.vote.list.vote6'), value: 6, checked: false },
            ],
        },
        {
            name: t('hotel.list.filter.star.title'),
            value: 'star',
            list: [
                { label: t('hotel.list.filter.star.list.star5'), value: 5, checked: false },
                { label: t('hotel.list.filter.star.list.star4'), value: 4, checked: false },
                { label: t('hotel.list.filter.star.list.star3'), value: 3, checked: false },
                { label: t('hotel.list.filter.star.list.star2'), value: 2, checked: false },
                { label: t('hotel.list.filter.star.list.star1'), value: 1, checked: false },
                { label: t('hotel.list.filter.star.list.star0'), value: 0, checked: false },
            ],
        },
        {
            name: t('hotel.list.filter.conditions.title'),
            value: 'conditions',
            list: [{ label: t('hotel.list.filter.conditions.list.cancellable'), value: 'cancellable', checked: false }],
        },
        {
            name: t('hotel.list.filter.themes.title'),
            value: 'themes',
            list: [],
        },
        {
            name: t('hotel.list.filter.amenities.title'),
            value: 'amenities',
            list: [],
        },
        {
            name: t('hotel.list.filter.features.title'),
            value: 'features',
            list: [],
        },
        {
            name: t('hotel.list.filter.distance.title'),
            value: 'distance',
            list: [
                { label: t('hotel.list.filter.distance.list.distance1'), value: 1, checked: false },
                { label: t('hotel.list.filter.distance.list.distance3'), value: 3, checked: false },
                { label: t('hotel.list.filter.distance.list.distance5'), value: 5, checked: false },
            ],
        },
    ]);

    const [filterData, setFilterData] = useState<any[]>([]);
    const [expandedPanel1] = useState<number | false>(false);

    const param = {
        start_date: `${checkInDate}`,
        end_date: `${checkOutDate}`,
        adults: Math.min(Math.max(isNaN(Number(adultGuest)) ? 0 : Number(adultGuest), 1), 4),
        children: childGuest,
    };

    const loadMoreData = (data: any) => {
        if (data.length > mockData.length) {
            let newMockData: any[] = data.slice(mockData.length, 10 * (page + 1));
            newMockData.unshift(...mockData);
            setMockData(newMockData);
            setPage(page + 1);
        }
    };

    const getData = useCallback((currency) => {
        setLoading(false);
        try {
            searchList({
                reference_id: Number(pCode?.slice(1)),
                reference_type: pReferenceType,
                start_date: checkInDate,
                end_date: checkOutDate,
                party: [
                    {
                        adults: Math.min(Math.max(isNaN(Number(adultGuest)) ? 0 : Number(adultGuest), 1), 4),
                        children: childGuest,
                    },
                ],
                lang: i18n.language,
                currency: currency,
                user_country: 'TR',
                device_type: 'Desktop',
                is_full: true,
            }).then((res: any) => {
                if (res.success) {
                    const data = res.data;
                    setAllMockData(data);
                    setAllFilterData(data);
                    setMockData(data.slice(0, 10));

                    setSearchName(res.search_name);

                    let URoom = queryParams.get('room');
                    let UFeatures = queryParams.get('features');
                    let UAmenities = queryParams.get('amenities');
                    let UThemes = queryParams.get('themes');

                    const tempFilter = defaultFilterData.map((item) => {
                        if (item.value === 'features') {
                            const tempList = res.filters.features || [];
                            const newList = tempList.map((list: any) => ({
                                label: list.label,
                                value: String(list.value),
                                checked: UFeatures?.includes(list.value) ? true : false,
                            }));
                            return {
                                ...item,
                                name: t('hotel.list.filter.features.title'),
                                list: newList,
                            };
                        }
                        if (item.value === 'amenities') {
                            const tempList = res.filters.amenities || [];
                            const newList = tempList.map((list: any) => ({
                                label: list.label,
                                value: String(list.value),
                                checked: UAmenities?.includes(list.value) ? true : false,
                            }));
                            return {
                                ...item,
                                name: t('hotel.list.filter.amenities.title'),
                                list: newList,
                            };
                        }
                        if (item.value === 'themes') {
                            const tempList = res.filters.themes || [];
                            const newList = tempList.map((list: any) => ({
                                label: list.label,
                                value: String(list.value),
                                checked: UThemes?.includes(list.value) ? true : false,
                            }));
                            return {
                                ...item,
                                name: t('hotel.list.filter.themes.title'),
                                list: newList,
                            };
                        }
                        if (item.value === 'room') {
                            const tempList = res.filters.pension || [];
                            const newFeaturesList = tempList.map((list: any) => ({
                                label: list.label,
                                value: String(list.value),
                                checked: URoom?.includes(list.value) ? true : false,
                            }));
                            return {
                                ...item,
                                name: t('hotel.list.filter.room.title'),
                                list: newFeaturesList,
                            };
                        }
                        if (item.value === 'vote') {
                            const newList = item.list.map((list: any) => ({
                                ...list,
                                label: t(`hotel.list.filter.vote.list.vote${list.value}`),
                            }));
                            return {
                                ...item,
                                name: t('hotel.list.filter.vote.title'),
                                list: newList,
                            };
                        }
                        if (item.value === 'star') {
                            const newList = item.list.map((list: any) => ({
                                ...list,
                                label: t(`hotel.list.filter.star.list.star${list.value}`),
                            }));
                            return {
                                ...item,
                                name: t('hotel.list.filter.star.title'),
                                list: newList,
                            };
                        }

                        if (item.value === 'conditions') {
                            const newList = item.list.map((list: any) => ({
                                ...list,
                                label: t(`hotel.list.filter.conditions.list.${list.value}`),
                            }));
                            return {
                                ...item,
                                name: t('hotel.list.filter.conditions.title'),
                                list: newList,
                            };
                        }
                        if (item.value === 'distance') {
                            const newList = item.list.map((list: any) => ({
                                ...list,
                                label: t(`hotel.list.filter.distance.list.distance${list.value}`),
                            }));
                            return {
                                ...item,
                                name: t('hotel.list.filter.distance.title'),
                                list: newList,
                            };
                        }

                        return { ...item, name: t(`hotel.list.filter.${item.value}.title`) };
                    });

                    setDefaultFilterData(tempFilter);
                    setFilterData(tempFilter);
                    setLoading(true);
                }
            });
        } catch (error) {
            setLoading(false);
        }
    }, []);

    const updatedFilterData = (): any[] => {
        let queryParamsTemp = new URLSearchParams(url.search);
        return defaultFilterData.map((item: any) => {
            const urlParamsItem = queryParamsTemp.get(item?.value || '');

            if (urlParamsItem) {
                const filterValues = String(urlParamsItem).includes(',')
                    ? String(urlParamsItem).split(',')
                    : [String(urlParamsItem)];

                item.list = item.list.map((item: any) => ({
                    ...item,
                    checked: filterValues.some((s: any) => String(s) === String(item.value)),
                }));
            }

            return item;
        });
    };
    //Filtre Fonksiyonu
    const handleFilterFunc = (dataIndex: any) => {
        setLoading(false);
        const type = filterData[dataIndex].value;
        const listArray = filterData[dataIndex].list.filter((f: any) => f.checked === true) || [];
        let tempUrl: string = url.search;
        const filterArr = ['vote', 'star', 'room', 'conditions', 'amenities', 'features', 'themes', 'distance'];

        filterArr.map((item: any) => {
            const urlParamsItem = queryParams.get(item);
            if (type === item) {
                urlParamsItem && (tempUrl = tempUrl.replaceAll(`&${item}=${urlParamsItem}`, ''));
                const tempType = listArray.map((item: any) => item.value).join(',');
                tempUrl += tempType ? `&${item}=${tempType}` : '';
            }
        });
        navigate(`${routesPaths[i18n.language].hotelList}/${location}${tempUrl}`);
        setTimeout(() => {
            setLoading(true);
        }, 300);
    };

    const priceFilter = (min: string, max: string) => {
        setLoading(false);
        let tempUrl: string = url.search;
        const minPriceItem = queryParams.get('minPrice');
        minPriceItem && (tempUrl = tempUrl.replaceAll(`&minPrice=${minPriceItem}`, ''));
        tempUrl += min ? `&minPrice=${min}` : '';

        const maxPriceItem = queryParams.get('maxPrice');
        maxPriceItem && (tempUrl = tempUrl.replaceAll(`&maxPrice=${maxPriceItem}`, ''));
        tempUrl += max ? `&maxPrice=${max}` : '';

        navigate(`${routesPaths[i18n.language].hotelList}/${location}${tempUrl}`);
        setTimeout(() => {
            setLoading(true);
        }, 300);
    };

    const sortFunc = (sortValue: any) => {
        setLoading(false);
        let tempUrl: string = url.search;
        const sortItem = queryParams.get('sort');

        if (sortValue === sortItem) {
            tempUrl = tempUrl.replace(`&sort=${sortValue}`, '');
        } else {
            sortItem && (tempUrl = tempUrl.replaceAll(`&sort=${sortItem}`, ''));
            tempUrl += sortValue ? `&sort=${sortValue}` : '';
        }

        navigate(`${routesPaths[i18n.language].hotelList}/${location}${tempUrl}`);
        setTimeout(() => {
            setLoading(true);
        }, 300);
    };
    const updateData = (data: any, url: any) => {
        let UQueryParams = new URLSearchParams(url);
        let USort = UQueryParams.get('sort');
        let UVote = UQueryParams.get('vote');
        let UStar = UQueryParams.get('star');
        let URoom = UQueryParams.get('room');
        let UFeatures = UQueryParams.get('features');
        let UAmenities = UQueryParams.get('amenities');
        let UThemes = UQueryParams.get('themes');
        let UDistance = UQueryParams.get('distance');
        let UConditions = UQueryParams.get('conditions');

        const newData = data
            .filter((item: any) => {
                let filterReturn = true;

                if (UFeatures) {
                    const numbers = UFeatures.split(',');
                    filterReturn &&= item.amenities.some((s: any) => numbers.includes(s));
                }
                if (UAmenities) {
                    const numbers = UAmenities.split(',');
                    filterReturn &&= item.amenities.some((s: any) => numbers.includes(s));
                }
                if (UThemes) {
                    const numbers = UThemes.split(',');
                    filterReturn &&= item.amenities.some((s: any) => numbers.includes(s));
                }
                if (UVote) {
                    const numbers = UVote.split(',').map(Number);
                    filterReturn &&= numbers.some((s: any) => (item.vote ? item.vote >= s : false));
                }
                if (UStar) {
                    const numbers = UStar.split(',').map(Number);
                    filterReturn &&= numbers.some((s: any) => item.rating == s);
                }
                if (URoom) {
                    const allowedRooms = URoom.split(',').map(Number);
                    filterReturn &&= allowedRooms.includes(item.pension_reference);
                }
                if (UDistance) {
                    const numbers = UDistance.split(',').map(Number);
                    filterReturn &&= numbers.some((s: any) => (item.km ? item.km <= s : false));
                }
                if (UConditions) {
                    if (UConditions.includes('cancellable')) {
                        filterReturn &&= item.cancellable === true;
                    }
                }
                if (queryMinPrice && queryMaxPrice) {
                    filterReturn &&= item.now_price >= Number(queryMinPrice) && item.now_price <= Number(queryMaxPrice);
                } else if (queryMinPrice) {
                    filterReturn &&= item.now_price >= Number(queryMinPrice);
                } else if (queryMaxPrice) {
                    filterReturn &&= item.now_price <= Number(queryMaxPrice);
                }

                return filterReturn;
            })
            .sort((a: any, b: any) => {
                if (USort) {
                    if (USort === 'asc') {
                        return (a.now_price || 0) - (b.now_price || 0);
                    }
                    if (USort === 'desc') {
                        return (b.now_price || 0) - (a.now_price || 0);
                    }
                    if (USort === 'rating') {
                        return (b.rating || 0) - (a.rating || 0);
                    }
                    if (USort === 'vote') {
                        return (b.vote || 0) - (a.vote || 0);
                    }
                    if (USort === 'distance') {
                        return (a.km || 0) - (b.km || 0);
                    }
                } else {
                    return (a.sort_index || 0) - (b.sort_index || 0);
                }

                return 1;
            });

        setAllFilterData(newData);
        setMockData(newData.slice(0, 10));
    };

    const NoResultBox = () => {
        return (
            <div className="error-box">
                <div className="icon">
                    <Info />
                </div>
                <div className="text">
                    <b>{t('hotel.list.noResult.title')}</b>
                    <br></br>
                    {t('hotel.list.noResult.text')}
                </div>
            </div>
        );
    };

    const sortList = [
        {
            label: t('hotel.list.sort.asc'),
            value: 'asc',
        },
        {
            label: t('hotel.list.sort.desc'),
            value: 'desc',
        },
        {
            label: t('hotel.list.sort.rating'),
            value: 'rating',
        },
        {
            label: t('hotel.list.sort.vote'),
            value: 'vote',
        },
        {
            label: t('hotel.list.sort.distance'),
            value: 'distance',
        },
    ];

    const SortComponent = (props: any) => {
        const { data } = props;
        return mediaBreakPoints.xltablet < media.width ? (
            <div className="sort-box">
                {data.map((item: any) => (
                    <Button
                        disabled={!loading}
                        style={{ opacity: !loading ? 0.5 : 1 }}
                        variant="outlined"
                        fullWidth
                        color={sort === item.value ? 'primary' : 'inherit'}
                        onClick={() => sortFunc(item.value)}
                    >
                        {item.label}
                    </Button>
                ))}
            </div>
        ) : (
            <React.Fragment>
                <Button
                    key={'sort-mobil-button'}
                    fullWidth
                    className="buttons"
                    variant="contained"
                    color="inherit"
                    onClick={() => setDrawer('sort')}
                >
                    <span className="select-label">
                        {data.find((option: any) => option.value === sort)?.label || t('hotel.list.sort.title')}
                    </span>
                </Button>

                <SwipeableDrawer
                    anchor={'bottom'}
                    open={drawer === 'sort'}
                    onClose={() => setDrawer('')}
                    onOpen={() => {}}
                    PaperProps={{
                        style: {
                            borderTopLeftRadius: 12,
                            borderTopRightRadius: 12,
                            maxHeight: 'calc(100% - 50px)',
                        },
                    }}
                >
                    <DrawerStyled>
                        <div className="title">
                            {t('hotel.list.sort.title')}
                            <IconButton onClick={() => setDrawer('')} className="close">
                                <Cancel fontSize="inherit" />
                            </IconButton>
                        </div>
                        <List disablePadding>
                            {data.map((item: any) => {
                                return (
                                    <ListItem disablePadding selected={item.value === sort}>
                                        <ListItemButton
                                            onClick={() => {
                                                sortFunc(item.value);
                                                setDrawer('');
                                            }}
                                        >
                                            <ListItemText primary={item.label} />
                                        </ListItemButton>
                                    </ListItem>
                                );
                            })}
                        </List>
                    </DrawerStyled>
                </SwipeableDrawer>
            </React.Fragment>
        );
    };

    const FilterComponent = (props: any) => {
        const { data } = props;
        return mediaBreakPoints.xltablet < media.width ? (
            <div className="filter-box">
                <div>
                    <div className="filter-title">
                        <div className="filter">{t('hotel.list.filter.title')}</div>
                        {isClearFilter && (
                            <div
                                className="clear"
                                onClick={() => {
                                    let parameter: string = '';
                                    if (checkInDate || checkOutDate) {
                                        parameter = `?checkInDate=${checkInDate}&checkOutDate=${checkOutDate}&guest=${guest}`;
                                        if (child) {
                                            parameter += `&child=${child}`;
                                        }
                                    }
                                    const url = data
                                        ? `${routesPaths[i18n.language].hotelList}/${location}${parameter}`
                                        : '';

                                    window.location.href = url;
                                }}
                            >
                                {t('hotel.list.filter.clear')}
                            </div>
                        )}
                    </div>
                    <div className="accordion-panel">
                        <Accordion defaultExpanded={queryMinPrice || queryMaxPrice ? true : false}>
                            <AccordionSummary
                                expandIcon={expandedPanel1 ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                            >
                                <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
                                    {t('hotel.list.filter.roomPrice.title')}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {(() => {
                                    const [minPrice, setMinPrice] = useState<any>(queryMinPrice || '');
                                    const [maxPrice, setMaxPrice] = useState<any>(queryMaxPrice || '');
                                    return (
                                        <Box display="flex" flexDirection="column" gap={2} pt={1} pb={2}>
                                            <CustomInput
                                                fullWidth
                                                size="small"
                                                label={t('hotel.list.filter.roomPrice.minPrice', {
                                                    currency: currentCurrency,
                                                })}
                                                variant="outlined"
                                                type="number"
                                                defaultValue={minPrice}
                                                onChange={(e: any) => setMinPrice(e.target.value)}
                                            />
                                            <CustomInput
                                                size="small"
                                                fullWidth
                                                label={t('hotel.list.filter.roomPrice.maxPrice', {
                                                    currency: currentCurrency,
                                                })}
                                                variant="outlined"
                                                type="number"
                                                defaultValue={maxPrice}
                                                onChange={(e: any) => setMaxPrice(e.target.value)}
                                            />
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                fullWidth
                                                onClick={() => priceFilter(minPrice, maxPrice)}
                                            >
                                                {t('hotel.list.filter.roomPrice.applyButton')}
                                            </Button>
                                        </Box>
                                    );
                                })()}
                            </AccordionDetails>
                        </Accordion>
                        {data.map((item: dataModel, index: number) => (
                            <AccordionPanel
                                key={index}
                                data={item}
                                handleCallback={(i: any, isChecked: any) => {
                                    const updatedFilterData = [...data];
                                    updatedFilterData[index].list[i].checked = isChecked;
                                    setFilterData(updatedFilterData);
                                    handleFilterFunc(index);
                                }}
                                expanded={expandedPanel1 === index}
                            />
                        ))}
                    </div>
                </div>
            </div>
        ) : (
            <React.Fragment>
                <Button
                    key={'filter-mobil-button'}
                    fullWidth
                    className="buttons"
                    variant="contained"
                    color="inherit"
                    startIcon={<FilterAlt />}
                    onClick={() => setDrawer('filter')}
                >
                    <span className="select-label">{t('hotel.list.filter.title')}</span>
                </Button>

                <SwipeableDrawer
                    anchor={'bottom'}
                    open={drawer === 'filter'}
                    onClose={() => setDrawer('')}
                    onOpen={() => {}}
                    PaperProps={{
                        style: {
                            // borderTopLeftRadius: 12,
                            // borderTopRightRadius: 12,
                            height: '100%',
                        },
                    }}
                >
                    <DrawerStyled>
                        <Box height="100%" display="flex" flexDirection="column" justifyContent="space-between">
                            <div className="title">
                                {t('hotel.list.filter.title')}
                                <IconButton onClick={() => setDrawer('')} className="close">
                                    <Cancel fontSize="inherit" />
                                </IconButton>
                            </div>
                            <div className="mobil-filter-box">
                                <div>
                                    <div className="accordion-panel">
                                        <Accordion defaultExpanded={queryMaxPrice || queryMinPrice ? true : false}>
                                            <AccordionSummary
                                                expandIcon={
                                                    expandedPanel1 ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />
                                                }
                                            >
                                                <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
                                                    {t('hotel.list.filter.roomPrice.title')}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                {(() => {
                                                    const [minPrice, setMinPrice] = useState<any>(queryMinPrice || '');
                                                    const [maxPrice, setMaxPrice] = useState<any>(queryMaxPrice || '');
                                                    return (
                                                        <Box
                                                            display="flex"
                                                            flexDirection="column"
                                                            gap={2}
                                                            pt={1}
                                                            pb={2}
                                                        >
                                                            <CustomInput
                                                                fullWidth
                                                                size="small"
                                                                label={t('hotel.list.filter.roomPrice.minPrice', {
                                                                    currency: currentCurrency,
                                                                })}
                                                                variant="outlined"
                                                                type="number"
                                                                defaultValue={minPrice}
                                                                onChange={(e: any) => setMinPrice(e.target.value)}
                                                            />
                                                            <CustomInput
                                                                size="small"
                                                                fullWidth
                                                                label={t('hotel.list.filter.roomPrice.maxPrice', {
                                                                    currency: currentCurrency,
                                                                })}
                                                                variant="outlined"
                                                                type="number"
                                                                defaultValue={maxPrice}
                                                                onChange={(e: any) => setMaxPrice(e.target.value)}
                                                            />
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                fullWidth
                                                                onClick={() => {
                                                                    priceFilter(minPrice, maxPrice);
                                                                    setDrawer('');
                                                                }}
                                                            >
                                                                {t('hotel.list.filter.roomPrice.applyButton')}
                                                            </Button>
                                                        </Box>
                                                    );
                                                })()}
                                            </AccordionDetails>
                                        </Accordion>
                                        {data.map((item: dataModel, index: number) => (
                                            <AccordionPanel
                                                key={index}
                                                data={item}
                                                handleCallback={(i: any, isChecked: any) => {
                                                    const updatedFilterData = [...data];
                                                    updatedFilterData[index].list[i].checked = isChecked;
                                                    setFilterData(updatedFilterData);
                                                    handleFilterFunc(index);
                                                }}
                                                expanded={expandedPanel1 === index}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <Box p={2} pb={0}>
                                <Button
                                    fullWidth
                                    size="large"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => setDrawer('')}
                                >
                                    {t('button.ok')}
                                </Button>
                            </Box>
                            {isClearFilter && (
                                <Box p={2} pb={0}>
                                    <Button
                                        fullWidth
                                        size="large"
                                        variant="contained"
                                        color="inherit"
                                        onClick={() => {
                                            let parameter: string = '';
                                            if (checkInDate || checkOutDate) {
                                                parameter = `?checkInDate=${checkInDate}&checkOutDate=${checkOutDate}&guest=${guest}`;
                                                if (child) {
                                                    parameter += `&child=${child}`;
                                                }
                                            }
                                            const url = data
                                                ? `${routesPaths[i18n.language].hotelList}/${location}${parameter}`
                                                : '';

                                            window.location.href = url;
                                        }}
                                    >
                                        {t('hotel.list.filter.clear')}
                                    </Button>
                                </Box>
                            )}
                        </Box>
                    </DrawerStyled>
                </SwipeableDrawer>
            </React.Fragment>
        );
    };

    const getCityData = useCallback(() => {
        setLoading(false);
        try {
            searchStatic({
                device_type: 'Desktop',
                reference_id: Number(pCode?.slice(1)),
                reference_type: pReferenceType,
                page_size: 0,
            }).then((res: any) => {
                if (res.success) {
                    const data = res.data;
                    setCityData(data);
                    setMockData(data.slice(0, 10));
                    setSearchName(res.search_name);
                    setSearchCity(res.city);
                    setSearchDistrict(res.district);
                    setSearchVillage(res.village);

                    let breadcrumbsList: any[] = [
                        <Link underline="none" key="1" color="primary" href={`${routesPaths[i18n.language].base}`}>
                            {t('hotel.list.breadcrumbs.home')}
                        </Link>,
                    ];

                    if (res.city) {
                        breadcrumbsList.push(
                            <Link
                                underline="none"
                                key="2"
                                color="primary"
                                href={hotelUrlGenerator({
                                    id: 'C' + res.city_reference,
                                    label: res.city + '-' + t('seo.hotelList.urlHotel'),
                                })}
                            >
                                {`${t('hotel.list.locationHotelTitle', {
                                    location: res.city,
                                })}`}
                            </Link>
                        );
                    }
                    if (res.district) {
                        breadcrumbsList.push(
                            <Link
                                underline="none"
                                key="2"
                                color="primary"
                                href={hotelUrlGenerator({
                                    id: 'D' + res.district_reference,
                                    label: res.district + '-' + t('seo.hotelList.urlHotel'),
                                })}
                            >
                                {`${t('hotel.list.locationHotelTitle', {
                                    location: res.district,
                                })}`}
                            </Link>
                        );
                    }
                    if (res.village) {
                        breadcrumbsList.push(
                            <Link
                                underline="none"
                                key="3"
                                color="primary"
                                href={hotelUrlGenerator({
                                    id: 'V' + res.village_reference,
                                    label: res.village + '-' + t('seo.hotelList.urlHotel'),
                                })}
                            >
                                {`${t('hotel.list.locationHotelTitle', {
                                    location: res.village,
                                })}`}
                            </Link>
                        );
                    }

                    setBreadcrumbs(breadcrumbsList);

                    setLoading(true);
                }
            });
        } catch (error) {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        paramsSize > 0 && updateData(allMockData, url.search);
    }, [url.search, allMockData]);

    useEffect(() => {
        paramsSize > 0 && setFilterData(updatedFilterData());
    }, [url.search]);

    useEffect(() => {
        paramsSize > 0 ? getData(currentCurrency) : getCityData();
    }, [i18n.language, currentCurrency]);

    useEffect(() => {
        data && handleBannerData();
    }, [data, i18n.language]);

    return (
        <Styled>
            {paramsSize > 0 && searchName ? (
                <SEO
                    title={t('seo.hotelList.title', {
                        location: searchName,
                    })}
                    noindex={true}
                />
            ) : (
                <SEO
                    title={t('seo.hotelStaticList.title', {
                        location: `${searchCity} ${searchDistrict} ${searchVillage}`.trim() || searchName,
                    })}
                    description={t('seo.hotelStaticList.description', {
                        location: `${searchCity} ${searchDistrict} ${searchVillage}`.trim() || searchName,
                    })}
                    pathName="hotelList"
                />
            )}

            {/* map dialog */}
            <Dialog
                fullWidth
                maxWidth="xl"
                onClose={() => {
                    setMapDialog(false);
                }}
                open={mapDialog ? true : false}
                PaperProps={{
                    sx: { margin: 0 },
                }}
            >
                <DialogMapStyled>
                    <IconButton
                        onClick={() => {
                            setMapDialog(false);
                        }}
                        className="close"
                    >
                        <Close fontSize="small" />
                    </IconButton>

                    <DialogContent>
                        <HotelListMap data={allFilterData} params={param} />

                        {/* Detay harita */}
                        {/* <HotelMap key={mapData.length} data={dataMapDetail} /> */}
                    </DialogContent>
                </DialogMapStyled>
            </Dialog>

            {/* map dialog end  */}

            <React.Fragment>
                <Container className="container">
                    <div className="search-bar-content">
                        {data && (
                            <HotelSearchBar
                                gtm={'otel'}
                                data={data && data}
                                showDetail={true}
                                searchName={searchName}
                            />
                        )}
                    </div>

                    {paramsSize > 0 ? (
                        <div className="page-container">
                            <div className="left">
                                <div className="map-box">
                                    <div
                                        className="image-container"
                                        onClick={() => {
                                            if (allFilterData.length > 0) {
                                                setMapDialog(true);
                                            }
                                        }}
                                    >
                                        <img src="/assets/images/otelmapbg.jpg" alt={`${t('global.showMap')}`} />
                                        <Button
                                            startIcon={<Map />}
                                            variant="contained"
                                            color="primary"
                                            className="centered-button"
                                        >
                                            {t('global.showMap')}
                                        </Button>
                                    </div>
                                </div>
                                {loading ? (
                                    <FilterComponent key={'FilterComponent-' + i18n.language} data={filterData} />
                                ) : (
                                    <div className="filter-box">
                                        {Array(5)
                                            .fill(null)
                                            .map((_, index) => (
                                                <Skeleton
                                                    key={`filter-box-skeleton-${index}`}
                                                    width={'100%'}
                                                    height={'50px'}
                                                    style={{ margin: '5px 0' }}
                                                />
                                            ))}
                                    </div>
                                )}

                                {/* <div className="sticky">
                                    <img
                                        className="bnr"
                                        src="https://dummyimage.com/270x420/f0f4f9/646a76.png"
                                        alt="Banner Alanı"
                                    />
                                </div> */}
                            </div>
                            <div className="right">
                                {/* Web  */}

                                {mediaBreakPoints.xltablet < media.width ? (
                                    <div className="page-header">
                                        <div className="page-title">
                                            {searchName ? (
                                                <>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                        <h1 className="h-title" style={{ margin: '5px 0' }}>
                                                            {t('hotel.list.locationHotelTitle', {
                                                                location: searchName,
                                                            })}
                                                        </h1>
                                                        {allFilterData.length > 0 && (
                                                            <p style={{ margin: 0, fontSize: 14, fontWeight: 400 }}>
                                                                (
                                                                {t('hotel.list.listLengthResult', {
                                                                    length: allFilterData.length,
                                                                })}
                                                                )
                                                            </p>
                                                        )}
                                                    </div>
                                                    <span>
                                                        <MiniAlert
                                                            className="info-alert"
                                                            text={t('hotel.list.listInfoText')}
                                                            showIcon={true}
                                                            icon={<Info />}
                                                        />
                                                    </span>
                                                </>
                                            ) : (
                                                <>
                                                    <Skeleton
                                                        width={'150px'}
                                                        height={'25px'}
                                                        style={{ margin: '5px 0' }}
                                                    />
                                                    <Skeleton width={'70px'} height={'18px'} />
                                                </>
                                            )}
                                        </div>

                                        <SortComponent key={'SortComponent-' + i18n.language} data={sortList} />
                                    </div>
                                ) : (
                                    <>
                                        {/* Mobil  */}
                                        <div className="mobile-buttons">
                                            {showMap ? (
                                                <Button
                                                    variant="contained"
                                                    fullWidth
                                                    className="buttons"
                                                    startIcon={<ListIcon />}
                                                    onClick={() => {
                                                        setShowMap(false);
                                                    }}
                                                >
                                                    {t('hotel.list.returnToListView')}
                                                </Button>
                                            ) : (
                                                <>
                                                    <FilterComponent
                                                        key={'FilterComponentMobil-' + i18n.language}
                                                        data={filterData}
                                                    />
                                                    <SortComponent
                                                        key={'SortComponentMobil-' + i18n.language}
                                                        data={sortList}
                                                    />
                                                    <Button
                                                        variant="contained"
                                                        fullWidth
                                                        className="buttons"
                                                        startIcon={<MapIcon />}
                                                        onClick={() => {
                                                            setShowMap(true);
                                                        }}
                                                    >
                                                        {t('hotel.list.map')}
                                                    </Button>
                                                </>
                                            )}
                                        </div>
                                    </>
                                )}
                                <div className="card-box">
                                    {!showMap ? (
                                        <>
                                            <>
                                                {loading ? (
                                                    <InfiniteScroll
                                                        dataLength={mockData.length}
                                                        next={() => loadMoreData(allFilterData)}
                                                        hasMore={allFilterData.length > mockData.length ? true : false}
                                                        loader={
                                                            allFilterData.length > mockData.length ? (
                                                                <Loading type="box" />
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                        scrollThreshold={'400px'}
                                                        // endMessage={}
                                                    >
                                                        <>
                                                            {mockData.length > 0 ? (
                                                                <div className="card-list">
                                                                    {mockData.map((item: any, index: number) => (
                                                                        <React.Fragment key={index}>
                                                                            {[2, 5, 10].map(
                                                                                (item: number, i: number) =>
                                                                                    item === index && (
                                                                                        <DynamicBanners
                                                                                            data={bannerData}
                                                                                            index={i}
                                                                                            className={'banner'}
                                                                                        />
                                                                                    )
                                                                            )}
                                                                            <HotelTicketCard
                                                                                key={index}
                                                                                data={item}
                                                                                params={param}
                                                                                isPopular={
                                                                                    paramsSize > 0 &&
                                                                                    paramsSize <= 3 &&
                                                                                    index < 2
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                            />
                                                                        </React.Fragment>
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                <NoResultBox />
                                                            )}
                                                        </>
                                                    </InfiniteScroll>
                                                ) : (
                                                    <div className="card-list">
                                                        {[0].map(() => (
                                                            <HotelTicketCard />
                                                        ))}
                                                        <Loading type="box" />
                                                    </div>
                                                )}
                                            </>
                                        </>
                                    ) : (
                                        <Drawer
                                            anchor={'bottom'}
                                            open={showMap}
                                            onClose={() => setShowMap(false)}
                                            ModalProps={{
                                                style: {
                                                    top: '72px',
                                                },
                                                BackdropProps: {
                                                    style: {
                                                        background: 'transparent',
                                                        pointerEvents: 'none',
                                                    },
                                                },
                                            }}
                                            hideBackdrop={false}
                                            PaperProps={{
                                                style: {
                                                    height: 'calc(100% - 72px)',
                                                },
                                            }}
                                        >
                                            <DrawerStyled>
                                                <Box
                                                    height="calc(100% + 30px)"
                                                    display="flex"
                                                    flexDirection="column"
                                                    justifyContent="space-between"
                                                    mt="-15px"
                                                    mb="-15px"
                                                >
                                                    <Box p={2}>
                                                        <Button
                                                            variant="contained"
                                                            fullWidth
                                                            color="inherit"
                                                            startIcon={<ListIcon />}
                                                            onClick={() => {
                                                                setShowMap(false);
                                                            }}
                                                        >
                                                            {t('hotel.list.returnToListView')}
                                                        </Button>
                                                    </Box>
                                                    <div className="mobil-map">
                                                        <HotelListMap
                                                            key={allFilterData.length}
                                                            data={allFilterData}
                                                            isMobile={true}
                                                            params={param}
                                                            mapFullScreen={true}
                                                        />
                                                    </div>
                                                </Box>
                                            </DrawerStyled>
                                        </Drawer>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="page-city-container">
                            {breadcrumbs.length > 0 && (
                                <div className="breadcrumbs">
                                    <Breadcrumbs
                                        style={{ fontSize: '12px', fontWeight: '600' }}
                                        className="breadcrumb"
                                        separator={<ArrowRight fontSize="small" color="primary" />}
                                        aria-label="breadcrumb"
                                    >
                                        {breadcrumbs}
                                    </Breadcrumbs>
                                </div>
                            )}

                            <div className="page-header" style={{ display: 'none' }}>
                                <div className="map-box">
                                    <div
                                        className="image-container"
                                        onClick={() => {
                                            if (cityData.length > 0) {
                                                setMapDialog(true);
                                            }
                                        }}
                                    >
                                        <img src="/assets/images/otelmapbg.jpg" alt={`${t('global.showMap')}`} />
                                        <Button
                                            startIcon={<Map />}
                                            size="small"
                                            variant="contained"
                                            color="primary"
                                            className="centered-button"
                                        >
                                            {t('global.showMap')}
                                        </Button>
                                    </div>
                                </div>
                                <Link href={routesPaths[i18n.language].register} className="register-box">
                                    <div className="text">
                                        <AccountCircleOutlined />
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: `${t('hotel.list.registerBanner')}`,
                                            }}
                                        ></span>
                                    </div>
                                </Link>
                            </div>

                            {searchName && (
                                <div className="page-title">
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        <h1 className="h-title">
                                            {t('hotel.list.locationHotelTitle', {
                                                location: searchName,
                                            })}
                                        </h1>

                                        {cityData.length > 0 && (
                                            <p style={{ margin: 0, fontSize: 14, fontWeight: 400 }}>
                                                (
                                                {t('hotel.list.listLengthResult', {
                                                    length: cityData.length,
                                                })}
                                                )
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}

                            <div className="card-box">
                                {loading ? (
                                    <InfiniteScroll
                                        dataLength={mockData.length}
                                        next={() => loadMoreData(cityData)}
                                        hasMore={cityData.length > mockData.length ? true : false}
                                        loader={cityData.length > mockData.length ? <Loading type="box" /> : <></>}
                                        scrollThreshold={'400px'}
                                        // endMessage={}
                                    >
                                        <>
                                            {mockData.length > 0 ? (
                                                <div className="card-list">
                                                    {mockData.map((item: any, index: number) => (
                                                        <React.Fragment key={index}>
                                                            {[2, 5, 10].map(
                                                                (item: number, i: number) =>
                                                                    item === index && (
                                                                        <DynamicBanners
                                                                            data={bannerData}
                                                                            index={i}
                                                                            className={'banner'}
                                                                        />
                                                                    )
                                                            )}
                                                            <HotelCityTicketCard key={index} data={item} />
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            ) : (
                                                <NoResultBox />
                                            )}
                                        </>
                                    </InfiniteScroll>
                                ) : (
                                    <div className="card-list">
                                        {[0].map(() => (
                                            <HotelCityTicketCard />
                                        ))}
                                        <Loading type="box" />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </Container>
                <Footer short={true} />
            </React.Fragment>
        </Styled>
    );
};
export default HotelList;
